export var firebaseConfig = {
    apiKey: "AIzaSyDFbYncXDkXyeINBgiO0IuE4aiVEWRiCv4",
    authDomain: "dine-oppskrifter.firebaseapp.com",
    databaseURL: "https://dine-oppskrifter.firebaseio.com",
    projectId: "dine-oppskrifter",
    storageBucket: "dine-oppskrifter.appspot.com",
    messagingSenderId: "844888763481",
    appId: "1:844888763481:web:33759056eff108a0"
};